"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GovParamChanges = void 0;
var Coins_1 = require("../Coins");
var numeric_1 = require("../numeric");
var GovParamChanges;
(function (GovParamChanges) {
    GovParamChanges.ConversionTable = {
        gov: {
            depositparams: [
                function (c) { return ({
                    min_deposit: Coins_1.Coins.fromData(c.min_deposit),
                    max_deposit_period: Number.parseInt(c.max_deposit_period),
                }); },
                function (c) { return ({
                    min_deposit: c.min_deposit.toData(),
                    max_deposit_period: c.max_deposit_period.toFixed(),
                }); },
            ],
            votingparams: [
                function (c) { return ({
                    voting_period: Number.parseInt(c.voting_period),
                }); },
                function (c) { return ({
                    voting_period: c.voting_period.toFixed(),
                }); },
            ],
            tallyparams: [
                function (c) { return ({
                    quorum: new numeric_1.Dec(c.quorum),
                    threshold: new numeric_1.Dec(c.threshold),
                    veto: new numeric_1.Dec(c.veto),
                }); },
                function (c) { return ({
                    quorum: c.quorum.toString(),
                    threshold: c.threshold.toString(),
                    veto: c.veto.toString(),
                }); },
            ],
        },
    };
})(GovParamChanges = exports.GovParamChanges || (exports.GovParamChanges = {}));
//# sourceMappingURL=params.js.map